import { Component, Input } from '@angular/core';
import { Participant } from '@models/Sessions/Participant';
import { Session } from '@models/Sessions/Session';
import { UserRelation } from '@models/Sessions/UserRelation';
import { BusService } from '@services/bus.service';
import { EventsService } from '@services/events.service';
import { SessionsRequestService } from '@services/sessions/sessions.request.service';
import _ from 'lodash';

@Component({
  selector: 'app-personal-results',
  templateUrl: './personal-results.component.html',
  styleUrls: ['./personal-results.component.scss'],
})
export class SessionModulesPersonalResultsComponent {
  private _session: Session;
  @Input() set session(value: Session) {
    this._session = value;
    this.calculateScores();
  }

  get session() {
    return this._session;
  }

  selectedUser: Participant | UserRelation;
  calculatedScores = {};

  constructor(
    private bus: BusService,
    private events: EventsService,
    private sessionRequest: SessionsRequestService,
  ) {}

  calculateScores() {
    this.selectedUser = this.session.me;

    _.forEach(this.session.scores.my_team, (user, key) => {
      this.calculatedScores[key] = {};
      this.calculatedScores[key].topscorer = this.calculateTopscorer(
        user.top_scorer.total,
        user.top_scorer.number,
      );
      this.calculatedScores[key].sparkcreator = this.calculateSparkcreator(
        user.spark_creator.total,
        user.spark_creator.number,
      );
      this.calculatedScores[key].improver = this.calculateImprover(
        user.improver.total,
        user.improver.number,
      );
      this.calculatedScores[key].challenger = this.calculateChallenger(
        user.challenger.number,
      );
      this.calculatedScores[key].sunshine = this.calculateSunshine(
        user.sunshine.number,
      );
      this.calculatedScores[key].solutionfinder = this.calculateSolutionfinder(
        user.solution_finder.number,
      );
    });
  }

  calculateTopscorer(total, number) {
    return {
      performance:
        Math.max(parseInt(number > 0 ? total / number : total, 10) * 15, 2) +
        'px',
      activity: Math.max(Math.min(parseInt(number, 10), 10) * 15, 2) + 'px',
    };
  }

  calculateSparkcreator(total, number) {
    return {
      performance:
        Math.max(parseInt(number > 0 ? total / number : total, 10) * 15, 2) +
        'px',
      activity: Math.max(Math.min(parseInt(number, 10), 10) * 15, 2) + 'px',
    };
  }

  calculateImprover(total, number) {
    return {
      performance:
        Math.max(parseInt(number > 0 ? total / number : total, 10) * 15, 2) +
        'px',
      activity: Math.max(Math.min(parseInt(number, 10), 10) * 15, 2) + 'px',
    };
  }

  calculateChallenger(number) {
    return {
      performance: Math.max(Math.min(parseInt(number, 10), 10) * 15, 2) + 'px',
      activity: Math.max(Math.min(parseInt(number, 10), 10) * 15, 2) + 'px',
    };
  }

  calculateSunshine(number) {
    return {
      performance: Math.max(Math.min(parseInt(number, 10), 10) * 15, 2) + 'px',
      activity: Math.max(Math.min(parseInt(number, 10), 10) * 15, 2) + 'px',
    };
  }

  calculateSolutionfinder(number) {
    return {
      performance: Math.max(Math.min(parseInt(number, 10), 10) * 15, 2) + 'px',
      activity: Math.max(Math.min(parseInt(number, 10), 10) * 15, 2) + 'px',
    };
  }

  selectUser(participant: Participant | UserRelation) {
    this.selectedUser = participant;
  }
}
